import React, { useState, useEffect, forwardRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = forwardRef((props, ref) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const isHome = location.pathname === '/';

  // Intersection Observer for transparent navbar on home
  useEffect(() => {
    if (!isHome) return;

    const hero = document.querySelector('.hero-video-section');
    if (!hero) return;

    let timeoutId;

    const observer = new IntersectionObserver(
      ([entry]) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          setIsScrolled(!entry.isIntersecting);
        }, 80);
      },
      {
        root: null,
        threshold: 0.3,
        rootMargin: '-10px 0px 0px 0px',
      }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, [isHome]);

  const headerClass = isHome && !isScrolled
    ? 'header-wrapper transparent'
    : 'header-wrapper';

  const isActive = (path) =>
    location.pathname === path ? 'menu-link active' : 'menu-link';

  const handleNavigation = (path) => {
    setMenuOpen(false);
    navigate(path);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50); // Ensures scroll after navigation
  };

  return (
    <header ref={ref} className={headerClass}>
      <div className="navbar">
        <div className="logo-container">
          <div className={`logo-bg ${isHome && !isScrolled ? 'transparent-bg' : ''}`}>
            <img src="/logo.png" alt="Sonal Holidays" className="logo-img" />
          </div>
        </div>

        <ul className={`menu-items ${menuOpen ? 'open' : ''}`}>
          <li><div onClick={() => handleNavigation('/')} className={isActive('/')}>Home</div></li>
          <li><div onClick={() => handleNavigation('/about-us')} className={isActive('/about-us')}>About Us</div></li>
          <li><div onClick={() => handleNavigation('/PopularDestinations')} className={isActive('/PopularDestinations')}>Destination</div></li>
          <li><div onClick={() => handleNavigation('/contact')} className={isActive('/contact')}>Contact Us</div></li>
        </ul>

        <div className="nav-actions">
          <div onClick={() => handleNavigation('/contact')} className="cta-button">
            Start Planning <span className="arrow">→</span>
          </div>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </div>
    </header>
  );
});

export default Navbar;
